import {NgxFiltersService} from "./ngx-filters.service";
import {Directive, EventEmitter, Injector, Input, OnChanges, OnInit, Output, SimpleChanges} from "@angular/core";
import {Filter, FilterTypes, NgxApplyFilterResult} from "./ngx-types";


@Directive({})
export abstract class NgxFiltersParentBase implements OnInit, OnChanges {
  public filtersService: NgxFiltersService
  abstract filters: Filter[] = [];
  abstract afterApply;
  filterCount = 0;
  innerFilters: Filter[] = [];
  abstract apply = new EventEmitter<NgxApplyFilterResult>();
  abstract filterChange = new EventEmitter<Filter>();
  abstract afterFilterChange: (filter: Filter) => Promise<any>;
  private _firstFilters: Filter[] = [];
  abstract filteredFilters: Filter[] = [];
  abstract filteredFiltersChange = new EventEmitter<Filter[]>();

  protected constructor(injector: Injector) {
    this.filtersService = injector.get(NgxFiltersService);
    this.filtersService.conditionSource = this.filtersService.getConditionSource();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.filters && changes.filters.currentValue) {
      this.populateInnerFilter();
    }
  }

  getClone(outerFilters: Filter[]): Filter[] {
    const filters = [];
    outerFilters.forEach(filter => {
      filters.push(
        {
          options: filter.options,
          hidden: filter.hidden,
          field: filter.field,
          conditionOperator: filter.conditionOperator,
          logicalOperator: filter.logicalOperator,
          label: filter.label,
          value: filter.value !== null && filter.value !== undefined ? typeof (filter.value) === 'object' && filter.type !== FilterTypes.DateTime ? {...filter.value} : filter.value : null,
          type: filter.type,
          valueTo: filter.valueTo,
          values: filter.values ? [...filter.values] : null,
          valuesName: filter.valuesName,
          valueName: filter.valueName,
          valueToName: filter.valueToName,
          conditionName: filter.conditionName,
          hasFilter: filter.hasFilter,
          hiddenCondition: filter.hiddenCondition,
          disabledCondition: filter.disabledCondition,
          conditionOperators: filter.conditionOperators,
          hideRemove: filter.hideRemove,
          displayLabel: filter.displayLabel
          // creationTime: filter['created']

        }
      );
    });
    return filters;
  }

  get filterTypes() {
    return FilterTypes;
  }

  applyFilter(filter: Filter): void {


    if (this.filtersService.checkHasFilter(filter)) {

      filter['created'] = (new Date()).getTime();
      filter.hasFilter = true;
      this.filtersService.setValueForDateHasNoValue(filter);

    } else {
      filter['created'] = 0;
    }
    if (this.afterFilterChange) {
      filter.displayLabel = this.filtersService.getDisplayLabel(filter);
      this.afterFilterChange(filter).then((result) => {
        this.filterChange.emit(filter);
        this.applyFilters();
        filter.displayLabel = result;
      });
    } else {
      filter.displayLabel = this.filtersService.getDisplayLabel(filter);
      this.filterChange.emit(filter);
      this.applyFilters();
    }
  }

  applyFilters(): void {
    // this.filters = [];
    setTimeout(() => {
      this._setFilterCount();
      this._getAndSetFilteredFilters();
      this.innerFilters = this._sort(this.innerFilters);
      this.filters = this.getClone(this.innerFilters);
      this.apply.emit({
        filters: this.filters,
        filteredFilters: this.filteredFilters,
        filtersQueryString: this.filtersService.getFiltersInQueryString(this.filteredFilters)
      });

    }, 10);
    if (this.afterApply) {
      this.afterApply();
    }
  }

  private mapFilters(filteredFilters): Filter[] {

    return filteredFilters.map(filter => {
      if (filter.type == FilterTypes.TrueFalse &&
        filter.value == false
        && filter.options?.trueFalseOptions?.falseIsNull == true) {
        filter.value = null;
      }
      if (filter.type == FilterTypes.SingleSelect || filter.type == FilterTypes.MultiSelect) {
        if (filter.type == FilterTypes.SingleSelect && filter.value) {
          filter.value = filter.value[filter?.options?.selectBoxOptions?.valueMember];
        } else if (filter.values) {
          filter.values = filter.values.map(va => {
            return va[filter?.options?.selectBoxOptions?.valueMember];
          });
        }
      }
      if (filter.type === FilterTypes.DateTime) {
        filter.value = this.filtersService.getTime(filter.value);
        filter.valueTo = this.filtersService.getTime(filter.valueTo);
      }
      return filter;
    });
  }

  private mapFiltersForFilteredFilters(filteredFilters: Filter[]): Filter[] {
    const items = [];
    filteredFilters.forEach(item => {
      items.push({
        value: item.value,
        values: item.values,
        type: item.type,
        logicalOperator: item.logicalOperator,
        conditionOperator: item.conditionOperator,
        field: item.field,
        valueTo: item.valueTo
      })
    });
    return items as any;
  }

  private _getAndSetFilteredFilters(): void {
    this.filteredFilters = this.mapFilters(this.getClone(this.innerFilters).filter(z => z.hasFilter));
    this.filteredFilters = this.mapFiltersForFilteredFilters(this.filteredFilters);
    this.filteredFiltersChange.emit(this.filteredFilters);

  }

  populateInnerFilter(): void {
    this.innerFilters = [];
    this.filters.forEach(item => {
      item.hasFilter = this.filtersService.checkHasFilter(item);
      this.filtersService.setValueForDateHasNoValue((item));
    });

    this.filters = this._sort(this.filters);

    this.innerFilters = this.getClone(this.filters);

    this._getAndSetFilteredFilters();

    this._firstFilters = this.getClone(this.filters);
    this._firstFilters.forEach(w => {
      w.values = null;
      w.value = null;
      w.valueToName = null;
      w.valuesName = null;
      w.hasFilter = false;
      w.valueTo = null;
    });
    this._setFilterCount();
  }

  private _setFilterCount(): void {
    this.filterCount = this.innerFilters.filter(z => z.hasFilter && !z.hidden)?.length;

  }

  ngOnInit(): void {
    // this.filtersService.useJalaliDate = this.useJalaliDate;
    // if (!this.isMobile) {
    // this.populateInnerFilter();
    // }
  }

  private _sort(filter: any[]): any[] {
    return filter.sort((a, b) => {
      let aa = a.hasFilter ? 0 : 1;
      if (a['created']) {
        aa = aa - a['created'];
      }
      let bb = b.hasFilter ? 0 : 1;
      if (b['created']) {
        bb = bb - b['created'];
      }
      return aa - bb;
    });
  }

  onClearAll(): void {
    this.innerFilters = this.getClone(this._firstFilters);
    this.filters = this.getClone(this._firstFilters);
    this.apply.emit({
      filters: this.filters,
      filteredFilters: [],
      filtersQueryString: null
    });
  }
}
